/** 教师相关接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'

// 分页
export function queryList(data) {
  return axios({
    url: path.mobile + '/teacherInfo',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

// 学生分页
export function studentPage(data) {
  return axios({
    url: path.mobile + '/teacherInfo/studentPage',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

// 选择老师
export function chooseTeacher(teacherCode, activityId, remark) {
  return axios({
    url: path.mobile + '/teacherInfo/chooseUser',
    method: 'PUT',
    data: {type: 1, teacherCode, activityId, remark},
  })
}

// 选择学生
export function chooseStudent(userCode, activityId, remark) {
  return axios({
    url: path.mobile + '/teacherInfo/chooseUser',
    method: 'PUT',
    data: {type: 0, userCode, activityId, remark},
  })
}

// 取消选择
export function cancelChoose(data) {
  return axios({
    url: path.mobile + '/teacherInfo/centerChoose',
    method: 'PUT',
    data: data,
  })
}

// 获取详情,包含额外信息
export function getDetail(id, activityId) {
  return axios({
    url: path.mobile + `/teacherInfo/id/${id}/${activityId}`,
    method: 'GET'
  })
}

// 获取详情,包含额外信息
export function getStudentDetail(id, activityId) {
  return axios({
    url: path.mobile + `/teacherInfo/getStudentDetail?id=${id}&activityId=${activityId}`,
    method: 'GET'
  })
}

// 同意/拒绝
export function affirmChoose(data) {
  return axios({
    url: path.mobile + '/teacherInfo/affirmChoose',
    method: 'PUT',
    data
  })
}

// 更新选择备注
export function updateChooseRemark(data) {
  return axios({
    url: path.mobile + '/teacherInfo/updateChooseRemark',
    method: 'PUT',
    data
  })
}

// 检查学生是否已经绑定教师
export function checkStudentBind(activityId) {
  return axios({
    url: path.mobile + '/teacherInfo/checkStudentBind/' + activityId,
    method: 'GET'
  })
}

// 检查学生是否已经绑定教师
export function checkTeacherLimit(activityId) {
  return axios({
    url: path.mobile + '/teacherInfo/checkTeacherLimit/' + activityId,
    method: 'GET'
  })
}

//////////////////////////////////////////////////////////////////////////

// 获取基本信息
export function getBaseDetail(id) {
  return axios({
    url: path.mobile + '/teacherInfo/comment/' + id,
    method: 'GET'
  })
}

// 添加教师评价信息
export function addComment(data) {
  return axios({
    url: path.mobile + '/teacherInfo/teacherComment/add',
    method: 'PUT',
    data: data,
  })
}

// 评价列表
export function getCommentList(data) {
  return axios({
    url: path.mobile + '/teacherInfo/teacherComment',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

